import { create } from "zustand";

interface RateLimitState {
  isOpen: boolean;
  message: string;
  tripName: string;
  setRateLimit: (message: string, tripName?: string) => void;
  clearRateLimit: () => void;
}

export const useRateLimitStore = create<RateLimitState>((set) => ({
  isOpen: false,
  message: "",
  tripName: "",
  setRateLimit: (message: string, tripName?: string) =>
    set({ isOpen: true, message, tripName }),
  clearRateLimit: () => set({ isOpen: false, message: "", tripName: "" }),
}));
